import { CChartLine } from '@coreui/react-chartjs'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormLabel,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import Loader from 'src/components/Loader'
import PlayerService from 'src/service/PlayerService'

const PlayerChart = () => {
  const [labelNames, setLabelNames] = useState([])
  const [playerList, setPlayerList] = useState([])
  const [priceChange, setPriceChange] = useState([])
  const [data, setData] = useState([])

  const [rsData, setRsData] = useState([])
  const [foursData, setFoursData] = useState([])
  const [sixesData, setSixesData] = useState([])
  const [mdnsData, setMdnsData] = useState([])
  const [wksData, setWksData] = useState([])

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    PlayerService.getAllPlayer().then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setPlayerList(res.data)
        setLoading(false)
      }
    })
  }, [])

  const handleSearchPlayer = (e) => {
    PlayerService.playerChart(e.target.value).then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setData(res.data.datasets)
        setLabelNames(res.data.labels)
        setPriceChange(res.data.priceChange)
        setRsData(res.data.runsData)
        setFoursData(res.data.foursData)
        setSixesData(res.data.sixesData)
        setMdnsData(res.data.mdnsData)
        setWksData(res.data.wksData)
        setLoading(false)
      }
    })
  }

  const labelNamesa = Object.keys(labelNames)
  const dataValues = Object.values(data).map((value) => parseFloat(value, 10))
  const dataPriceChangeValues = Object.values(priceChange).map((value) => parseFloat(value, 10))

  const dataRunsValues = Object.values(rsData).map((value) => parseFloat(value, 10))
  const dataFoursValues = Object.values(foursData).map((value) => parseFloat(value, 10))
  const dataSixesValues = Object.values(sixesData).map((value) => parseFloat(value, 10))
  const dataMdnsValues = Object.values(mdnsData).map((value) => parseFloat(value, 10))
  const dataWksValues = Object.values(wksData).map((value) => parseFloat(value, 10))

  const formattedData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fantasy Points',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataValues,
      },
    ],
  }
  const formattedPriceChangeData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fantasy Value',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataPriceChangeValues,
      },
    ],
  }

  const formattedRunseData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Runs',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataRunsValues,
      },
    ],
  }

  const formattedFoursData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fours',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataFoursValues,
      },
    ],
  }

  const formattedSixesData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Sixes',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataSixesValues,
      },
    ],
  }

  const formattedMdnsData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Maidens',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataMdnsValues,
      },
    ],
  }

  const formattedWksData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Wickets',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataWksValues,
      },
    ],
  }

  return loading ? (
    <Loader />
  ) : (
    <>
      <CRow>
        <CCol xs={12} sm={12} lg={12}>
          <CCard className="mb-4">
            <CCardHeader>Select Player</CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md={6}>
                  <CFormSelect
                    aria-label="Select player"
                    name="player"
                    className={'form-control'}
                    onChange={handleSearchPlayer}
                    id="player"
                  >
                    <option value={0}>Select Player</option>
                    {playerList &&
                      playerList.map((item, key) => (
                        <option value={item?.id} key={key}>
                          {item?.full_name}
                        </option>
                      ))}
                  </CFormSelect>
                </CCol>
                <CCol md={6}>&nbsp;</CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Fantasy Points</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Fantasy Value</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedPriceChangeData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        {/* <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Runs</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedRunseData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Fours</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedFoursData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Sixes</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedSixesData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Maidens</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedMdnsData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Wickets</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedWksData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol> */}
      </CRow>
    </>
  )
}

export default PlayerChart
